export const getHtmlWithSignature = (html, signatureData, receiverName) => {
  if (!html || !html.htmlContent || typeof html.htmlContent !== "string") return "";
  if (!signatureData) return html.htmlContent;

  const hasEnglishFields = /Signature:|Date:|Recipient:/i.test(html.htmlContent);
  const hasHebrewCharacters = /[\u0590-\u05FF]/.test(html.htmlContent);
  
  const isHebrew = hasHebrewCharacters && !hasEnglishFields;
  
  let modifiedContent = html.htmlContent;

  // 1. Вставляем имя получателя
  if (receiverName) {
    const namePatterns = [
      /(שם המקבל:[:\s]*)/i,
      /(Name of Recipient:[:\s]*)/i
    ];
    
    for (const pattern of namePatterns) {
      if (pattern.test(modifiedContent)) {
        modifiedContent = modifiedContent.replace(pattern, `$1 ${receiverName}`);
        break; 
      }
    }
  }

  // 2. Вставляем текущую дату и время
  const now = new Date();
  const dateStr = `${now.getDate().toString().padStart(2, "0")}/${(now.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${now.getFullYear().toString().slice(-2)}`;
  const timeStr = `${now.getHours().toString().padStart(2, "0")}:${now
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;
  const dateTimeFormatted = `${dateStr} ${timeStr}`;

  const datePatterns = [
    /(תאריך:[:\s]*)/i,
    /(Date:[:\s]*)/i
  ];

  for (const pattern of datePatterns) {
    const globalPattern = new RegExp(pattern.source, pattern.flags + 'g');
    const matches = modifiedContent.match(globalPattern);
    
    if (matches && matches.length >= 1) {
      let occurrence = 0;
      const isEnglishPattern = /Date:/i.test(pattern.source);
      const targetOccurrence = isEnglishPattern ? matches.length : 1;

      modifiedContent = modifiedContent.replace(globalPattern, (match) => {
        occurrence++;
        if (occurrence === targetOccurrence) {
          return `${match} ${dateTimeFormatted}`;
        }
        return match;
      });
      break;
    }
  }

  // 3. Подпись (Signature)
  const signaturePlaceholder = "<!-- SIGNATURE_PLACEHOLDER -->";
 
  const signatureStyle = isHebrew 
    ? "max-width: 200px; position: absolute; bottom: 7%; left: 23%; transform: translateX(-50%); pointer-events: none;"
    : "max-width: 200px; position: absolute; bottom: 7%; right: 23%; transform: translateX(50%); pointer-events: none;";

  const signatureHtml = `<img src="${signatureData}" style="${signatureStyle}" />`;

  if (modifiedContent.includes(signaturePlaceholder)) {
    return modifiedContent.replace(signaturePlaceholder, signatureHtml);
  }

  const signaturePatterns = [
    /חתימה:(?:[^\s]*\s+){1,2}(?:[^\s]*\s+){1,2}(?:[^\s]*\s+){1,2}[^\s]*[:\s]*<\/[^>]*>/gi,
    /Signature:(?:[^\s]*\s+){1,2}(?:[^\s]*\s+){1,2}(?:[^\s]*\s+){1,2}[^\s]*[:\s]*<\/[^>]*>/gi,
    /Signature:[:\s]*<\/[^>]*>/gi
  ];

  for (const pattern of signaturePatterns) {
    const matches = modifiedContent.match(pattern);
    if (matches && matches.length >= 1) {
      const targetOccurrence = matches.length >= 2 ? 2 : 1;
      let occurrence = 0;
      
      modifiedContent = modifiedContent.replace(pattern, (match) => {
        occurrence++;
        if (occurrence === targetOccurrence) {
          return `<span style="position: relative; display: inline-block;">${match}${signatureHtml}</span>`;
        }
        return match;
      });
      break;
    }
  }

  return modifiedContent;
};